import { render, staticRenderFns } from "./OverallVaccinations.vue?vue&type=template&id=e55bf17e&"
import script from "./OverallVaccinations.vue?vue&type=script&lang=js&"
export * from "./OverallVaccinations.vue?vue&type=script&lang=js&"
import style0 from "./OverallVaccinations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports